var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "所属门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: { placeholder: "请选择门店" },
                                      on: { change: _vm.loadAll },
                                      model: {
                                        value: _vm.storeId,
                                        callback: function ($$v) {
                                          _vm.storeId = $$v
                                        },
                                        expression: "storeId",
                                      },
                                    },
                                    _vm._l(_vm.storeOptionList, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "printer", attrs: { tab: "打印机" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-operator" },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handlePrinterAdd },
                                },
                                [_vm._v("新增打印机")]
                              )
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              attrs: { icon: "reload" },
                              on: { click: _vm.loadPrinters },
                            },
                            [_vm._v("刷新")]
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.printerColumns,
                          dataSource: _vm.printers,
                          scroll: _vm.scroll,
                          loading: _vm.loading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "printerAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePrinterTest(record)
                                        },
                                      },
                                    },
                                    [_vm._v("测试")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlePrinterEdit(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _vm._e(),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlePrinterDelete(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "printerStatus",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color:
                                        _vm.statusColor[record.displayStatus] ||
                                        "default",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.statusText[record.displayStatus] ||
                                          record.displayStatus ||
                                          "未知"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "connectType",
                            fn: function (text) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.connectTypeText[text] || text)
                                ),
                              ]
                            },
                          },
                          {
                            key: "targetInfo",
                            fn: function (text, record) {
                              return [
                                record.targetType === "local"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(record.localPrinterName || "-")
                                      ),
                                    ])
                                  : record.ip
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(record.ip) +
                                          ":" +
                                          _vm._s(record.port || 9100)
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(record.cloudVendor || "-")),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "station", attrs: { tab: "厨房档口" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-operator" },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleStationAdd },
                                },
                                [_vm._v("新增档口")]
                              )
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              attrs: { icon: "coffee" },
                              on: { click: _vm.handleAssignStation },
                            },
                            [_vm._v("菜品分配档口")]
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.stationColumns,
                          dataSource: _vm.stations,
                          scroll: _vm.scroll,
                          loading: _vm.loading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "stationAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleStationEdit(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _vm._e(),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleStationDelete(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "stationPrinter",
                            fn: function (text) {
                              return [_vm._v(_vm._s(_vm.printerName(text)))]
                            },
                          },
                          {
                            key: "granularity",
                            fn: function (text) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.granularityText[text] || text)
                                ),
                              ]
                            },
                          },
                          {
                            key: "mergeSame",
                            fn: function (text) {
                              return [
                                _vm._v(
                                  _vm._s(text === "1" ? "合并" : "不合并")
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "gateway", attrs: { tab: "打印网关" } },
                    [
                      _c("a-alert", {
                        staticStyle: { "margin-bottom": "12px" },
                        attrs: {
                          type: "info",
                          "show-icon": "",
                          message:
                            "网关是运行在门店收银机上的打印服务（dining-print-gateway）：新建记录后生成配对码，在网关控制台输入 ERP 地址+配对码完成绑定，绑定后长轮询拉单打印。",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "table-operator" },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleGatewayAdd },
                                },
                                [_vm._v("新增网关")]
                              )
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              attrs: { icon: "reload" },
                              on: { click: _vm.loadGateways },
                            },
                            [_vm._v("刷新")]
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.gatewayColumns,
                          dataSource: _vm.gateways,
                          scroll: _vm.scroll,
                          loading: _vm.loading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "gatewayAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePairCode(record)
                                        },
                                      },
                                    },
                                    [_vm._v("生成配对码")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleGatewayDelete(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "gwStatus",
                            fn: function (text) {
                              return [
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color:
                                        text === "online" ? "green" : "default",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        text === "online" ? "在线" : "离线"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "template", attrs: { tab: "小票模板" } },
                    [
                      _c("a-alert", {
                        staticStyle: { "margin-bottom": "12px" },
                        attrs: {
                          type: "info",
                          "show-icon": "",
                          message:
                            "行式模板：控制各单据类型的标题与打印内容开关，保存即时生效（租户配置覆盖系统默认）。",
                        },
                      }),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "billType",
                          columns: _vm.templateColumns,
                          dataSource: _vm.templates,
                          loading: _vm.loading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "templateAction",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleTemplateEdit(record)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                              ])
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "log", attrs: { tab: "打印日志" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            { attrs: { layout: "inline" } },
                            [
                              _c(
                                "a-row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { md: 5, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "单据",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: "全部类型",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value: _vm.logQuery.billType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.logQuery,
                                                    "billType",
                                                    $$v
                                                  )
                                                },
                                                expression: "logQuery.billType",
                                              },
                                            },
                                            _vm._l(
                                              _vm.billTypeText,
                                              function (v, k) {
                                                return _c(
                                                  "a-select-option",
                                                  {
                                                    key: k,
                                                    attrs: { value: k },
                                                  },
                                                  [_vm._v(_vm._s(v))]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 5, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "状态",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: "全部状态",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value: _vm.logQuery.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.logQuery,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "logQuery.status",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "pending" } },
                                                [_vm._v("待下发")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                {
                                                  attrs: { value: "delivered" },
                                                },
                                                [_vm._v("已下发")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "success" } },
                                                [_vm._v("成功")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "failed" } },
                                                [_vm._v("失败")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "manual" } },
                                                [_vm._v("转人工")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 14, sm: 24 } },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.loadLogs(1)
                                            },
                                          },
                                        },
                                        [_vm._v("查询")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { icon: "reload" },
                                          on: { click: _vm.resetLogQuery },
                                        },
                                        [_vm._v("重置")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.logColumns,
                          dataSource: _vm.logs,
                          scroll: _vm.scroll,
                          loading: _vm.loading,
                          pagination: {
                            current: _vm.logQuery.pageNo,
                            pageSize: _vm.logQuery.pageSize,
                            total: _vm.logTotal,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50"],
                            onChange: _vm.loadLogs,
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "logAction",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleReprint(record)
                                      },
                                    },
                                  },
                                  [_vm._v("补打")]
                                ),
                              ])
                            },
                          },
                          {
                            key: "logBillType",
                            fn: function (text) {
                              return [
                                _vm._v(_vm._s(_vm.billTypeText[text] || text)),
                              ]
                            },
                          },
                          {
                            key: "logStatus",
                            fn: function (text) {
                              return [
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color:
                                        _vm.logStatusColor[text] || "default",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.logStatusText[text] || text)
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "logTime",
                            fn: function (text) {
                              return [_vm._v(_vm._s(text || "-"))]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("printer-modal", {
                ref: "printerModal",
                attrs: {
                  "store-id": _vm.storeId,
                  gateways: _vm.gateways,
                  stations: _vm.stations,
                },
                on: { ok: _vm.loadPrinters },
              }),
              _c("station-modal", {
                ref: "stationModal",
                attrs: { "store-id": _vm.storeId, printers: _vm.printers },
                on: { ok: _vm.loadStations },
              }),
              _c("goods-station-modal", {
                ref: "goodsStationModal",
                attrs: { stations: _vm.stations },
              }),
              _c("template-modal", {
                ref: "templateModal",
                on: { ok: _vm.loadTemplates },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "新增打印网关",
                    visible: _vm.gatewayAddVisible,
                    confirmLoading: _vm.confirmLoading,
                  },
                  on: {
                    ok: _vm.doGatewayAdd,
                    cancel: function ($event) {
                      _vm.gatewayAddVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "网关名称",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "如：前台收银机" },
                        on: { pressEnter: _vm.doGatewayAdd },
                        model: {
                          value: _vm.gatewayName,
                          callback: function ($$v) {
                            _vm.gatewayName = $$v
                          },
                          expression: "gatewayName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    { staticStyle: { color: "#999", margin: "0 0 0 16.6%" } },
                    [
                      _vm._v(
                        "创建后点击「生成配对码」，在网关控制台输入 ERP 地址与配对码完成绑定。"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }